// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"d46a1772","613":"0e76d5d3"}[chunkId] + ".chunk.js";
};